<template>
  <div>
    <div class="fw-bold mb-1">
      Step {{ getCurrentStepIndex + 1 }} of {{ getTotalSteps }}
    </div>
    <div class="progress border border-secondary shadow-sm">
      <div
        class="progress-bar text-start"
        role="progressbar"
        :style="`width: ${percent}%`"
        :aria-valuenow="percent"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ProgressBar",
  computed: {
    ...mapGetters(["getCurrentStepIndex", "getTotalSteps"]),
    percent() {
      if (!this.getTotalSteps || this.getTotalSteps <= 0) {
        return 0;
      }

      return Math.floor(
        (100 / this.getTotalSteps) * (this.getCurrentStepIndex + 1)
      );
    }
  }
};
</script>

<style scoped>
.progress {
  height: 8px;
}
</style>
